import React from "react";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, Checkbox, Collapse, Typography } from "antd";
import { CREATE_TEAM_MUTATION } from "./queries";
import { Team, TeamSettings } from "./interface";

const { Text } = Typography;
const { Panel } = Collapse;

export const CreateTeam: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<Team>({
    resource: "teams",
    meta: {
      gqlMutation: CREATE_TEAM_MUTATION,
    },
  });

  // Initialize settings object
  const settingsValues = formProps.form?.getFieldValue('settings') || {};

  const handleSettingsChange = (settingName: keyof TeamSettings, value: boolean) => {
    const currentSettings = formProps.form?.getFieldValue('settings') || {};
    const newSettings = {
      ...currentSettings,
      [settingName]: value
    };
    formProps.form?.setFieldsValue({ settings: newSettings });
  };

  return (
    <Create saveButtonProps={saveButtonProps} title="Create Team">
      <Form layout="vertical" {...formProps}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter team name" }]}
        >
          <Input placeholder="Enter team name" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea placeholder="Enter description" rows={3} />
        </Form.Item>
        
        <Collapse ghost>
          <Panel header="Team Settings" key="settings">
            <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
              Configure team-specific preferences and behavior
            </Text>
            
            <Form.Item label="Settings" name="settings" style={{ display: 'none' }}>
              <Input />
            </Form.Item>
            
            <Form.Item
              label="Optional Requirement Date on Plans"
              name={['settings', 'OptionalRequirementDateOnPlan']}
              valuePropName="checked"
            >
              <Checkbox 
                onChange={(e) => handleSettingsChange('OptionalRequirementDateOnPlan', e.target.checked)}
              >
                Allow requirement date to be optional on procurement plans
              </Checkbox>
            </Form.Item>
            
            <Text type="secondary" style={{ fontSize: 12 }}>
              When enabled, team members can create procurement plans without specifying a requirement date.
            </Text>
          </Panel>
        </Collapse>
      </Form>
    </Create>
  );
};